module.exports = __webpack_public_path__ + "img/InfoOutline.61feb0d9b.svg";